import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "network-io"
    }}>{`Network I/O`}</h1>
    <p>{`Many plugin scenarios require use of the network to fetch or push data, to browse remote resources, and to synchronize content, among other reasons. XD implements a robust network stack.`}</p>
    <p>{`UXP supports `}<inlineCode parentName="p">{`fetch`}</inlineCode>{`, `}<inlineCode parentName="p">{`XHR`}</inlineCode>{` (XML HTTP Request), and `}<inlineCode parentName="p">{`WebSockets`}</inlineCode>{`. Of these, the easiest to use is `}<inlineCode parentName="p">{`fetch`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      